// extracted by mini-css-extract-plugin
export default {"container":"pz-z","dimension":"qz-z","dimensionLabels":"rz-z"};